import React, { useEffect, useRef } from "react";
import "./NewLand.css";

const WHATSAPP_NUMBER = "6587428153";

const DEFAULT_MESSAGE =
  "Hi WhalesAI, I have an AI idea and would like to discuss building a platform.";

const waLink = (message = DEFAULT_MESSAGE) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

const Icon = ({ children, ...rest }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...rest}
  >
    {children}
  </svg>
);

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
  </svg>
);

const icons = {
  layers: (
    <>
      <path d="M12 2 2 7l10 5 10-5-10-5z" />
      <path d="m2 17 10 5 10-5" />
      <path d="m2 12 10 5 10-5" />
    </>
  ),

  app: (
    <>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M3 9h18" />
      <path d="M7 6.5h.01M10 6.5h.01" />
      <path d="M8 14h8M8 17h5" />
    </>
  ),

  zap: <path d="M13 2 3 14h9l-1 8 10-12h-9l1-8z" />,

  sparkle: (
    <>
      <path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z" />
      <path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z" />
    </>
  ),

  plug: (
    <>
      <path d="M9 2v6M15 2v6" />
      <path d="M6 8h12v4a6 6 0 0 1-12 0z" />
      <path d="M12 18v4" />
    </>
  ),

  bulb: (
    <>
      <path d="M9 18h6M10 22h4" />
      <path d="M12 2a7 7 0 0 0-4 12.7c.6.5 1 1.3 1 2.1V17h6v-.2c0-.8.4-1.6 1-2.1A7 7 0 0 0 12 2z" />
    </>
  ),

  code: (
    <>
      <path d="m16 18 6-6-6-6" />
      <path d="m8 6-6 6 6 6" />
    </>
  ),

  cpu: (
    <>
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <rect x="9" y="9" width="6" height="6" />
      <path d="M9 1v3M15 1v3M9 20v3M15 20v3M20 9h3M20 14h3M1 9h3M1 14h3" />
    </>
  ),

  globe: (
    <>
      <circle cx="12" cy="12" r="10" />
      <path d="M2 12h20" />
      <path d="M12 2a15.3 15.3 0 0 1 0 20 15.3 15.3 0 0 1 0-20z" />
    </>
  ),

  card: (
    <>
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <path d="M2 10h20M6 15h4" />
    </>
  ),

  cycle: (
    <>
      <path d="M21 12a9 9 0 1 1-2.6-6.4L21 8" />
      <path d="M21 3v5h-5" />
    </>
  ),

  trend: (
    <>
      <path d="m22 7-8.5 8.5-5-5L2 17" />
      <path d="M16 7h6v6" />
    </>
  ),

  arrow: (
    <>
      <path d="M5 12h14" />
      <path d="m12 5 7 7-7 7" />
    </>
  ),
};

const services = [
  {
    icon: "layers",
    title: "AI SaaS Platforms",
    text: "Build your own AI-powered subscription platform with users, accounts, billing, credits and usage management.",
  },
  {
    icon: "app",
    title: "AI Applications",
    text: "Turn your business idea into a custom AI-powered web application.",
  },
  {
    icon: "zap",
    title: "AI Automation",
    text: "Automate business processes using AI, APIs and intelligent workflows.",
  },
  {
    icon: "sparkle",
    title: "AI Content Platforms",
    text: "Build platforms for AI-generated text, images, video, audio and other digital content.",
  },
  {
    icon: "plug",
    title: "AI API Integration",
    text: "Connect your platform with AI models and third-party APIs.",
  },
  {
    icon: "bulb",
    title: "Custom AI Solutions",
    text: "If you have a specific AI idea, we’ll help turn it into a working product.",
  },
];

const steps = [
  {
    num: "01",
    title: "DISCUSS",
    text: "Tell us about your idea, business and what you want to achieve.",
  },
  {
    num: "02",
    title: "PLAN",
    text: "We determine the technology, AI workflow and platform architecture required.",
  },
  {
    num: "03",
    title: "BUILD",
    text: "Our development team builds your AI platform and integrates the required technologies and APIs.",
  },
  {
    num: "04",
    title: "LAUNCH",
    text: "Your platform is deployed and ready for your customers or business.",
  },
];

const features = [
  {
    icon: "code",
    title: "Custom Development",
    text: "Your platform is designed around your business requirements.",
  },
  {
    icon: "cpu",
    title: "AI Integration",
    text: "Integrate the AI models and APIs required for your product.",
  },
  {
    icon: "globe",
    title: "Web Platform",
    text: "Build modern, responsive platforms accessible from anywhere.",
  },
  {
    icon: "card",
    title: "Monetisation",
    text: "Subscriptions, usage-based billing, credits and other commercial models.",
  },
  {
    icon: "cycle",
    title: "Automation",
    text: "Connect AI with your existing business processes and systems.",
  },
  {
    icon: "trend",
    title: "Scalability",
    text: "Build a foundation that can grow as your users and business grow.",
  },
];

const ideas = [
  "Launch an AI SaaS startup",
  "Build an AI-powered business platform",
  "Create your own AI content system",
  "Automate your company’s workflow",
  "Develop an AI chatbot or assistant",
  "Build a custom AI application",
  "Connect multiple AI models through one platform",
  "Turn an existing business idea into an AI product",
];

const ideaMessage = (idea) =>
  `Hi WhalesAI, I'd like to discuss this: ${idea.charAt(0).toLowerCase()}${idea.slice(1)}.`;

const WhatsAppButton = ({ label, large = false, message }) => (
  <a
    className={`wai-btn wai-btn--wa${large ? " wai-btn--lg" : ""}`}
    href={waLink(message)}
    target="_blank"
    rel="noopener noreferrer"
  >
    <WhatsAppIcon />
    {label}
  </a>
);

export default function NewLand() {
  const rootRef = useRef(null);

  useEffect(() => {
    const elements =
      rootRef.current?.querySelectorAll(".wai-reveal") || [];

    if (!("IntersectionObserver" in window)) {
      elements.forEach((element) => element.classList.add("is-in"));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.12,
      }
    );

    elements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="wai" ref={rootRef}>
      {/* HERO */}
      <header className="wai-hero">
        <div className="wai-hero__bg" aria-hidden="true">
          <div className="wai-hero__grid" />
          <div className="wai-hero__glow" />

          <div className="wai-sonar">
            <span />
            <span />
            <span />
          </div>
        </div>

        <div className="wai-container wai-hero__inner">
          <div className="wai-hero__content">
            <p className="wai-eyebrow">
              Build your AI platform with WhalesAI
            </p>

            <h1>
              Turn Your AI Idea Into a <em>Real Business</em>
            </h1>

            <p className="wai-hero__text">
              We design and develop custom AI platforms, SaaS products, AI
              applications and automation systems for businesses, startups and
              entrepreneurs.

              <strong>
                From your initial idea to a working AI platform — we build it
                with you.
              </strong>
            </p>

            <div className="wai-hero__cta">
              <WhatsAppButton
                label="Talk to us on WhatsApp"
                large
              />

              <p className="wai-note">
                Tell us what you want to build. No obligation.
              </p>
            </div>
          </div>

          <div className="wai-chat" aria-hidden="true">
            <div className="wai-chat__top">
              <div className="wai-chat__avatar">
                <Icon>{icons.sparkle}</Icon>
              </div>

              <div>
                <div className="wai-chat__name">WhalesAI</div>
                <div className="wai-chat__status">online</div>
              </div>

              <div className="wai-chat__wa">
                <WhatsAppIcon />
              </div>
            </div>

            <div className="wai-chat__body">
              <div className="wai-bubble wai-bubble--me">
                Hi! I want to launch an AI platform where my customers can
                generate content and pay with credits.
              </div>

              <div className="wai-bubble wai-bubble--them">
                Great idea. Let’s plan it together — here’s what we’d build:

                <div className="wai-chat__stack">
                  <span className="wai-chip">User accounts</span>
                  <span className="wai-chip">AI model APIs</span>
                  <span className="wai-chip">Credits &amp; billing</span>
                  <span className="wai-chip">Admin dashboard</span>
                </div>
              </div>

              <div className="wai-bubble wai-bubble--me">
                Perfect. When can we start?
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* SERVICES */}
      <section className="wai-section">
        <div className="wai-container">
          <div className="wai-head wai-head--split wai-reveal">
            <div>
              <p className="wai-eyebrow">Have an AI idea?</p>
              <h2 className="wai-h2">We can build it.</h2>
            </div>

            <p className="wai-lead">
              Whether you want to launch an AI startup, add AI to your
              existing business, or build a completely new AI-powered product,
              WhalesAI can develop the technology behind it.
            </p>
          </div>

          <div className="wai-services wai-reveal">
            {services.map((service) => (
              <article className="wai-service" key={service.title}>
                <div className="wai-service__icon">
                  <Icon>{icons[service.icon]}</Icon>
                </div>

                <h3>{service.title}</h3>
                <p>{service.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* PROCESS */}
      <section className="wai-section wai-section--alt">
        <div className="wai-container">
          <div className="wai-head wai-reveal">
            <p className="wai-eyebrow">How it works</p>
            <h2 className="wai-h2">From idea to platform</h2>
          </div>

          <ol className="wai-steps wai-reveal">
            {steps.map((step) => (
              <li className="wai-step" key={step.num}>
                <div className="wai-step__num">{step.num}</div>

                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      {/* FEATURES */}
      <section className="wai-section">
        <div className="wai-container">
          <div className="wai-head wai-reveal">
            <p className="wai-eyebrow">What you get</p>
            <h2 className="wai-h2">Built for real businesses</h2>
          </div>

          <div className="wai-features wai-reveal">
            {features.map((feature) => (
              <div className="wai-feature" key={feature.title}>
                <div className="wai-feature__icon">
                  <Icon>{icons[feature.icon]}</Icon>
                </div>

                <div>
                  <h3>{feature.title}</h3>
                  <p>{feature.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* IDEAS */}
      <section className="wai-section wai-section--alt">
        <div className="wai-container wai-ideas">
          <div className="wai-ideas__aside wai-reveal">
            <p className="wai-eyebrow">Your project</p>

            <h2 className="wai-h2">
              What do you want to build?
            </h2>

            <p className="wai-lead">Maybe you want to:</p>

            <p className="wai-ideas__hint">
              <WhatsAppIcon />
              Tap any idea to start a WhatsApp chat about it.
            </p>
          </div>

          <div className="wai-reveal">
            <ul className="wai-wishes">
              {ideas.map((idea) => (
                <li key={idea}>
                  <a
                    className="wai-wish"
                    href={waLink(ideaMessage(idea))}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="wai-wish__arrow">
                      <Icon>{icons.arrow}</Icon>
                    </span>

                    {idea}

                    <span className="wai-wish__go">
                      <WhatsAppIcon />
                      Discuss
                    </span>
                  </a>
                </li>
              ))}
            </ul>

            <p className="wai-ideas__end">
              Whatever your idea, let’s discuss it.
            </p>
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section className="wai-cta" id="contact">
        <div className="wai-container wai-cta__inner wai-reveal">
          <WhatsAppButton
            label="Contact us via WhatsApp"
            large
          />
        </div>
      </section>

      {/* FLOATING WHATSAPP */}
      <a
        className="wai-fab"
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with WhalesAI on WhatsApp"
      >
        <WhatsAppIcon />
      </a>
    </div>
  );
}

